/**
 * Title Component: How-To Schema
 */
import { RichText } from '@wordpress/block-editor';
import { createBlock } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';

const Title = (props) => {
	const {
		attributes,
		setAttributes,
		mergeBlocks,
		insertBlocksAfter,
		onReplace,
	} = props;

	if (setAttributes !== 'not_set') {
		return (
			<RichText
				tagName={attributes.headingTag}
				placeholder={__('Write a Heading')}
				value={attributes.howtoChildTitle}
				className="wpsp-ifb-title"
				onChange={(value) => setAttributes({ howtoChildTitle: value })}
				multiline={false}
				onMerge={mergeBlocks}
				onSplit={
					insertBlocksAfter
						? (before, after, ...blocks) => {
								setAttributes({ content: before });
								insertBlocksAfter([
									...blocks,
									createBlock('core/paragraph', {
										content: after,
									}),
								]);
						  }
						: undefined
				}
				onRemove={() => onReplace([])}
			/>
		);
	}
	return (
		<RichText.Content
			tagName={attributes.headingTag}
			value={attributes.howtoChildTitle}
			className="wpsp-ifb-title"
		/>
	);
};

export default Title;
